import { useSelector } from "react-redux";

import { AppState } from "../data/reducers";

export function useCbtGuestData({ index, indexPassenger }) {
  const {
    cbt,
    bookingFormSection,
    cbtGuestsInDynamicFormShowingSearchForm,
    rooms,
  } = useSelector((state: AppState) => ({
    cbt: state.cbt,
    bookingFormSection: state.bookingForm.bookingFormSections[index],
    cbtGuestsInDynamicFormShowingSearchForm:
      state.bookingForm.cbtGuestsInDynamicFormShowingSearchForm,
    rooms: state.search.searchHotels.rooms,
  }));

  const isCbtGuest = getIsCbtGuestFromCbtAndBookingFormSectionAndIndex(
    cbt,
    bookingFormSection,
    index,
    rooms
  );

  const showCbtGuestSearchForm =
    isCbtGuest &&
    cbtGuestsInDynamicFormShowingSearchForm?.includes(indexPassenger);

  const setShowCbtGuestSearchForm = () => {};

  const indexGuest = indexPassenger;

  return {
    showCbtGuestSearchForm,
    setShowCbtGuestSearchForm,
    indexGuest,
  };
}

function getIsCbtGuestFromCbtAndBookingFormSectionAndIndex(
  cbt,
  bookingFormSection,
  index,
  rooms
) {
  const countAllGuests = () => {
    if (!rooms || !Array.isArray(rooms)) return 0;
    return rooms.reduce((total, room) => total + (room.guests || 0), 0);
  };

  const numCbtTravellers =
    (cbt?.passengersForm?.travellers?.length || 0) +
    (cbt?.passengersForm?.guests + countAllGuests() || 0);

  if (numCbtTravellers === 0) {
    return false;
  }

  if (cbt.corporate === null) {
    return false;
  }

  if (!bookingFormSection.title.startsWith("CODE-")) {
    return false;
  }

  if (index < (cbt.passengersForm?.travellers?.length || 0)) {
    return false;
  }

  return true;
}
